export const COIN_ID_COSMOS = 'ATOM'

export const COIN_ID_BITCOIN_CASH = 'BCH'

export const COIN_ID_BITCOIN = 'BTC'

export const COIN_ID_CARDANO = 'ADA'

export const COIN_ID_CHAINLINK = 'LINK'

export const COIN_ID_DOGECOIN = 'DOGE'

export const COIN_ID_ETHEREUM = 'ETH'

export const COIN_ID_FILECOIN = 'FIL'

export const COIN_ID_LITECOIN = 'LTC'

export const COIN_ID_POLKADOT = 'DOT'

export const COIN_ID_RIPPLE = 'XRP'

export const COIN_ID_STELLAR = 'XLM'

export const CURRENCY_NAME: Record<string, string> = {
  [COIN_ID_COSMOS]: 'Cosmos',

  [COIN_ID_BITCOIN_CASH]: 'Bitcoin cash',

  [COIN_ID_BITCOIN]: 'Bitcoin',

  [COIN_ID_CARDANO]: 'Cardano',

  [COIN_ID_CHAINLINK]: 'Chainlink',

  [COIN_ID_DOGECOIN]: 'Dogecoin',

  [COIN_ID_ETHEREUM]: 'Ethereum',

  [COIN_ID_FILECOIN]: 'Filecoin',

  [COIN_ID_LITECOIN]: 'Litecoin',

  [COIN_ID_POLKADOT]: 'Polkadot',

  [COIN_ID_RIPPLE]: 'Ripple',

  [COIN_ID_STELLAR]: 'Stellar',
}

